import { render, staticRenderFns } from "./whatapp-chat.vue?vue&type=template&id=42899546&scoped=true&"
import script from "./whatapp-chat.vue?vue&type=script&lang=js&"
export * from "./whatapp-chat.vue?vue&type=script&lang=js&"
import style0 from "./whatapp-chat.vue?vue&type=style&index=0&id=42899546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42899546",
  null
  
)

export default component.exports